// extracted by mini-css-extract-plugin
export var active = "_bq-7";
export var container = "_bq-0";
export var evenWidth = "_bq-4";
export var large = "_bq-5";
export var outlet = "_bq-8";
export var slide = "_bq-2";
export var small = "_bq-6";
export var tab = "_bq-3";
export var tabs = "_bq-1";